import React from "react";

import KeyboardInput from "../InputKeyboard";
import { t } from "../../../helpers/translator";
import Helpers from "../../../helpers/helperFunctions";

export default function dmsRegisterFields () {
    const letters = /^[a-zA-Z\s]*$/;    
    const disabled = !(this.validatePhone(this.state.Phone) && this.validateEmail(this.state.Email) && this.isInputValid(this.state.Name, this.state.Surname, this.state.Phone) && this.props.isAdminLoggedIn && this.isFormValid() && Helpers.validateCNP(this.state.CNP) && Helpers.isCNP18plus(this.state.CNP) && this.state.bTag)

    return <div>
        <div className="title-popup-page-m-dms">
            <p className='auth-popup-title'>{t("Registration")}</p>
            {
                this.props.popupParams && this.props.popupParams.disable ? null : <button className="popup-closed-b" onClick={this.registerPopupForDms()}/>
            }
        </div>
        <div className="ticket-results-view-p">
            <form className="ticketin-popup">
                <div className="popup-contain-table-m login-form-m">
                    <div className="registor-contain-form-d">
                        <div className="reg-cont-box">
                            <p className='single-form-item-title'>{t('Name')}</p>
                            <div className="single-form-item">
                                <KeyboardInput type='text' onChange={this.handleNameChange}/>
                                {(this.state.Name.length !== 0 && (this.state.Name.length < 3 || !this.state.Name.match(letters))) && <p className='field-is-not-correct'>{t("Contain at least 3 charachters and only letter")}</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <form className="ticketin-popup">
                <div className="popup-contain-table-m login-form-m">
                    <div className="registor-contain-form-d">
                        <div className="reg-cont-box">
                            <p className='single-form-item-title'>{t('Surname')}</p>
                            <div className="single-form-item">
                                <KeyboardInput type='text' onChange={this.handleSurNameChange}/>
                                {(this.state.Surname.length !== 0 && (this.state.Surname.length < 3 || !this.state.Surname.match(letters))) && <p className='field-is-not-correct'>{t("Contain at least 3 charachters and only letter")}</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <form className="ticketin-popup">
                <div className="popup-contain-table-m login-form-m">
                    <div className="registor-contain-form-d">
                        <div className="reg-cont-box">
                            <p className='single-form-item-title'>{t('CNP')}</p>
                            <div className="single-form-item">
                                <KeyboardInput type='text' onChange={this.handleCnpChange}/>
                                {(this.state.CNP !== '' && !Helpers.validateCNP(this.state.CNP)) && <p className='field-is-not-correct'>{t("CNP is not correct")}</p>}
                                {(this.state.CNP !== '' && Helpers.validateCNP(this.state.CNP) && !Helpers.isCNP18plus(this.state.CNP)) && <p className='field-is-not-correct'>{t("You need to be over 18")}</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <form className="ticketin-popup">
                <div className="popup-contain-table-m login-form-m">
                    <div className="registor-contain-form-d">
                        <div className="reg-cont-box">
                            <p className='single-form-item-title'>{t('Phone')}</p>
                            <div className="single-form-item">
                                <KeyboardInput numeric type='text' value={this.state.Phone} onChange={this.handlePhoneChange}/>
                                {this.state.Phone && !this.validatePhone(this.state.Phone) && <p className='field-is-not-correct'>{t("Must contain at least 10 Numbers and only numbers”")}</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <form className="ticketin-popup">
                <div className="popup-contain-table-m login-form-m">
                    <div className="registor-contain-form-d">
                        <div className="reg-cont-box">
                            <p className='single-form-item-title'>{t('Email')}</p>
                            <div className="single-form-item">
                                <KeyboardInput type='text' onChange={this.handleEmailChange}/>
                                {this.state.Email.length !==0 && !this.validateEmail(this.state.Email) && <p className='field-is-not-correct'>{t("Please enter valid email”")}</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <form className="ticketin-popup">
                <div className="popup-contain-table-m login-form-m">
                    <div className="registor-contain-form-d">
                        <div className="reg-cont-box">
                            <p className='single-form-item-title'>{t('Card Serial Number')}</p>
                            <div className="single-form-item">
                                <KeyboardInput type='text' onChange={this.handleBTagChange}/>
                                {/* {this.state.BTag.length !==0 && !this.validateEmail(this.state.BTag) && <p className='field-is-not-correct'>{t("Please enter valid email”")}</p>} */}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            {/* {Config.main.rfidPinCode && <DmsRegisterPinCodeFields onFormValidChange={this.changePinCodeFormValidState}  />} */}
            <form className="ticketin-popup">
                <div className="popup-contain-table-m login-form-m">
                    <div className="registor-contain-form-d">
                        <div className="reg-cont-box">
                            {/*<div className="single-form-item register-checkbox-item">*/}
                            {/*    <input type="checkbox" className="register-checkbox" onChange={ this.handleChecked }/>*/}
                            {/*    <span className='register-check'/>*/}
                            {/*    <p className='agree-txt'>{t("I agree with the GDPR TERMS of the provided by the state")}</p>*/}
                            {/*</div>*/}
                            <label className='container-check single-form-item register-checkbox-item'>
                                <input type='checkbox' className="register-checkbox" onChange={this.handleChecked} />
                                <span className='checkmark'/>
                                <p className='agree-txt'>{t("I agree with the GDPR TERMS of the provided by the state")}</p>
                            </label>
                        </div>
                    </div>
                </div>
            </form>
            {/* {(!this.props.isAdminLoggedIn || !this.isFormValid()) && <p>{t("Please ask administrator for confirmation")}</p>} */}
            {(!this.props.isAdminLoggedIn) && <p>{t("Please ask administrator for confirmation")}</p>}
            <div className='separator-box-buttons-m-wrap'>
                <div className="separator-box-buttons-m">
                    <button className={!disabled ? "button-view-normal-m" : "button-view-normal-m trans-m"}
                            disabled={disabled}
                            onClick={this.state.isChecked && this.confirmRegistration()}>
                        {t("Confirm Registration")}
                    </button>
                </div>
                <div className="separator-box-buttons-m">
                    <button className="button-view-normal-m trans-m" onClick={this.props.closePopup()}>
                        {t("Cancel")}
                    </button>
                </div>
            </div>
        </div>
    </div>;
}
